import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CreateAccount from '../components/pmcReg/CreateAccount';
import ExistingEmail from '../components/pmcReg/ExistingEmail';
import CheckEmail from '../components/pmcReg/CheckEmail';
import EmailVerified from '../components/pmcReg/EmailVerified';
import ContactDetails from '../components/pmcReg/ContactDetails';
import AccessCodeMobile from '../components/pmcReg/AccessCodeMobile';
import MobileVerified from '../components/pmcReg/MobileVerified';
import IncorrectVerificationCode from '../components/pmcReg/IncorrectVerificationCode';
import CreatePassword from '../components/pmcReg/CreatePassword';
import PasswordCreated from '../components/pmcReg/PasswordCreated';
import CompanyRegistrationNumber from '../components/pmcReg/CompanyRegistrationNumber';
import ConfirmBusinessDetails from '../components/pmcReg/ConfirmBusinessDetails';
import CheckAnswers from '../components/pmcReg/CheckAnswers';
import Declaration from '../components/pmcReg/Declaration';
import AccountCreated from '../components/pmcReg/AccountCreated';
import AuthRoute from '../AuthRoute';
import LandlordType from '../components/pmcReg/LandlordType';
import CompanyVATNumber from '../components/pmcReg/CompanyVATNumber';
import ConfirmVAT from '../components/pmcReg/ConfirmVAT';
import CannotProceed from '../components/pmcReg/CannotProceed';
import DashboardPMC from '../components/dashboardHub/DashboardPMC';

export default function RoutesTreePmcReg() {
  return (
    <Switch>
      {/* *************************** */}
      {/* PMC Registration routes */}
      {/* *************************** */}
      <Route exact path="/dashboardHub/dashboard-pmc">
        <DashboardPMC />
      </Route>
      <Route exact path="/pmcReg/type-of-landlord">
        <LandlordType />
      </Route>
      <Route exact path="/pmcReg/create-account">
        <CreateAccount />
      </Route>
      <AuthRoute exact path="/pmcReg/check-email" isAnonymous>
        <CheckEmail />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/email-verified" isAnonymous>
        <EmailVerified />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/contact-details" isAnonymous>
        <ContactDetails />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/access-code-mobile" isAnonymous>
        <AccessCodeMobile />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/mobile-verified" isAnonymous>
        <MobileVerified />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/create-password" isAnonymous>
        <CreatePassword />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/password-created" isAnonymous>
        <PasswordCreated />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/company-registration-number" isAnonymous>
        <CompanyRegistrationNumber />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/confirm-business-details" isAnonymous>
        <ConfirmBusinessDetails />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/company-VAT-number" isAnonymous>
        <CompanyVATNumber />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/confirm-business-VAT" isAnonymous>
        <ConfirmVAT />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/check-your-answers" isAnonymous>
        <CheckAnswers />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/declaration" isAnonymous>
        <Declaration />
      </AuthRoute>
      <Route exact path="/pmcReg/account-created">
        <AccountCreated />
      </Route>
      <AuthRoute exact path="/pmcReg/cannot-proceed" isAnonymous>
        <CannotProceed />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/incorrect-verification-code" isAnonymous>
        <IncorrectVerificationCode />
      </AuthRoute>
      <AuthRoute exact path="/pmcReg/existing-email" isAnonymous>
        <ExistingEmail />
      </AuthRoute>
      {/* *************************** */}
      {/* PMC Registration routes */}
      {/* *************************** */}
    </Switch>
  );
}
